/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import ClearIcon from "@mui/icons-material/Clear";
import "./AltSelect.css";

const AltSelect = ({
  options = [], //{title:"",value:""} or {ojb,obj}
  name = "name",
  onChange,
  errors = [],
  formValues,
  label = "",
  id = "",
  otherText = "Other (User defined)",
  ...props
}) => {
  const [value, setValue] = useState(formValues?.[`${name}`] || null);
  const [inputType, setInputType] = useState("select");

  //useEffects
  useEffect(() => {
    if (value === "-other-") {
      onChange({ target: { name: name, value: null } });
      setInputType("text");
      setTimeout(() => {
        setValue(null);
      }, 400);
    } else {
      onChange({ target: { name: name, value: value } });
    }
  }, [value]);

  useEffect(() => {
    if (formValues?.[`${name}`]) {
      if (
        options?.find(
          (x) =>
            x === formValues?.[`${name}`] ||
            x?.value === formValues?.[`${name}`]
        )
      ) {
        setInputType("select");
      } else {
        setInputType("text");
      }
    }
  }, []);

  //methods
  const handleChange = (e) => {
    setValue(e?.target?.value);
  };

  const handleCloseFreeText = () => {
    onChange({ target: { name: name, value: null } });
    setValue(null);
    setInputType("select");
  };
  //builders
  return (
    <div className="alt-select">
      {inputType === "select" && (
        <TextField
          required
          fullWidth
          margin="dense"
          autoComplete="new-password"
          variant="outlined"
          error={errors[`${name}`] ? true : false}
          helperText={errors[`${name}`] ? errors?.[`${name}`]?.[0] : null}
          name={"select"}
          select
          id={id}
          label={label}
          onChange={handleChange}
          value={value}
          {...props}
        >
          {[...options, { title: otherText, value: "-other-" }].map(
            (option) => (
              <MenuItem key={option.title} value={option?.value || option}>
                {option?.title || option}
              </MenuItem>
            )
          )}
        </TextField>
      )}

      {inputType === "text" && (
        <>
          <TextField
            key={"input-category"}
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors[`${name}`] ? true : false}
            helperText={errors[`${name}`] ? errors?.[`${name}`]?.[0] : null}
            name={"text"}
            label={label}
            id={id}
            onChange={handleChange}
            value={value || ""}
            {...props}
          />
          <div className="close-icon" onClick={handleCloseFreeText}>
            <ClearIcon />
          </div>
        </>
      )}
    </div>
  );
};

export default AltSelect;
